(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3274,1502],{

/***/ 11295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_getAvatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26221);
/* harmony import */ var _fallbackImage_fallbackImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37562);




const avatar_placeholder = "/images/avatar_placeholder.png";
function Avatar(param) {
    let { data  } = param;
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils_getAvatar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(data === null || data === void 0 ? void 0 : data.img));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fallbackImage_fallbackImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fill: true,
        src: imgSrc,
        alt: data === null || data === void 0 ? void 0 : data.firstname,
        sizes: "60px",
        onError: ()=>setImgSrc(avatar_placeholder)
    });
}


/***/ }),

/***/ 77262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98456);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 37562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76098);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 90026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(34349);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(64698);
;// CONCATENATED MODULE: ./utils/numberToPrice.ts
const numberToPrice = function(number) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (number) {
        return number.toFixed(digits).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    return "0";
};

;// CONCATENATED MODULE: ./components/price/price.tsx





function Price(param) {
    let { number =0 , minus , symbol , plus , digits , old  } = param;
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const position = (currency === null || currency === void 0 ? void 0 : currency.position) || "before";
    const currencySymbol = symbol || (currency === null || currency === void 0 ? void 0 : currency.symbol) || "$";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat(minus ? "red" : "", " ").concat(old ? "strike" : ""),
        children: [
            minus ? "-" : "",
            plus ? "+" : "",
            position === "before" ? currencySymbol : "",
            numberToPrice(number, digits),
            position === "after" ? currencySymbol : ""
        ]
    });
}


/***/ }),

/***/ 21502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProfileDropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58203);
/* harmony import */ var _profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var containers_popover_popover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56060);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22120);
/* harmony import */ var hooks_usePopover__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58287);
/* harmony import */ var components_avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11295);
/* harmony import */ var remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46550);
/* harmony import */ var remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _profileDropdownLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83594);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29969);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13597);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var remixicon_react_Wallet3LineIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5458);
/* harmony import */ var remixicon_react_Wallet3LineIcon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Wallet3LineIcon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var components_price_price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90026);
/* harmony import */ var utils_getNearestFloor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30405);














function ProfileDropdown(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const [open, anchorEl, handleOpen, handleClose] = (0,hooks_usePopover__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const { logout , isAuthenticated , openAuthModal , openWalletHistory , user  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const handleLogout = ()=>{
        logout();
        handleClose();
    };
    const actualLinks = !isAuthenticated ? _profileDropdownLinks__WEBPACK_IMPORTED_MODULE_7__/* .profileDropdownLinks.filter */ .a.filter((item)=>!item.requiredAuth) : _profileDropdownLinks__WEBPACK_IMPORTED_MODULE_7__/* .profileDropdownLinks */ .a;
    if (!isAuthenticated) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().login),
            onClick: ()=>openAuthModal(),
            children: t("login")
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                "aria-label": "Profile",
                className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().profileBtn),
                onClick: handleOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().imgWrapper),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        data: data
                    }, data.img)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_popover_popover__WEBPACK_IMPORTED_MODULE_1__["default"], {
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: 40
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().closeIcon),
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().profileImage),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        data: data
                                    }, data.img)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().naming),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/profile",
                                        className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
                                        children: [
                                            data === null || data === void 0 ? void 0 : data.firstname,
                                            " ",
                                            data === null || data === void 0 ? void 0 : (ref = data.lastname) === null || ref === void 0 ? void 0 : ref.charAt(0),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().flex),
                                    onClick: ()=>{
                                        handleClose();
                                        openWalletHistory();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Wallet3LineIcon__WEBPACK_IMPORTED_MODULE_10___default()), {
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text),
                                            children: [
                                                t("wallet"),
                                                ":",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().price),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price_price__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        number: (0,utils_getNearestFloor__WEBPACK_IMPORTED_MODULE_13__/* .getNearestFloor */ .n)(user === null || user === void 0 ? void 0 : (ref1 = user.wallet) === null || ref1 === void 0 ? void 0 : ref1.price)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "wallet"),
                                actualLinks.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: item.href,
                                        className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().flex),
                                        onClick: handleClose,
                                        children: [
                                            item.icon,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text),
                                                children: t(item.label)
                                            })
                                        ]
                                    }, item.href)),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().flex),
                                    onClick: handleLogout,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_9___default()), {
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_profileDropdown_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text),
                                            children: t("logout")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 83594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73755);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31654);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4134);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72275);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25039);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12331);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26428);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55549);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 84169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5848);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3075);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21697);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 74006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WelcomeBlog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72746);
/* harmony import */ var _welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86886);
/* harmony import */ var components_fallbackImage_fallbackImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37562);
/* harmony import */ var remixicon_react_InstagramLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25857);
/* harmony import */ var remixicon_react_InstagramLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_InstagramLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94187);
/* harmony import */ var remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18074);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21697);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);










function WelcomeBlog(param) {
    let { data  } = param;
    const { t  } = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_6__/* .useSettings */ .r)();
    if (data) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().container),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "welcome-container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heading),
                                    children: t("latest.blog")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    href: "/blog",
                                    className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                                            children: t("see.all")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                            container: true,
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().card),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                                children: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().body),
                                                dangerouslySetInnerHTML: {
                                                    __html: (data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.description) && (data === null || data === void 0 ? void 0 : (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description.length) > 499 ? "".concat(data === null || data === void 0 ? void 0 : (ref3 = data.translation) === null || ref3 === void 0 ? void 0 : ref3.description.slice(0, 500), "...") : (data === null || data === void 0 ? void 0 : (ref4 = data.translation) === null || ref4 === void 0 ? void 0 : ref4.description) || ""
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
                                                href: "/blog/".concat(data === null || data === void 0 ? void 0 : data.uuid),
                                                children: t("read.more")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imgWrapper),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fallbackImage_fallbackImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: data === null || data === void 0 ? void 0 : data.img,
                                            alt: data === null || data === void 0 ? void 0 : (ref5 = data.translation) === null || ref5 === void 0 ? void 0 : ref5.title,
                                            fill: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: settings === null || settings === void 0 ? void 0 : settings.instagram_url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().socialCard),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_InstagramLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().label),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                                                        children: t("view.our.insta")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {})
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().card),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().badge),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                                                    children: t("ads")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                                children: "Broccoli Bacon Salad"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat((_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().body), " ").concat((_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().small)),
                                                children: [
                                                    "This easy chicken and broccoli casserole is ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " a quick one-skillet dinner fix that's a guaranteed ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " crowd pleaser."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_welcomeBlog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().float),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fallbackImage_fallbackImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    src: "/images/broccoli.png",
                                                    alt: "Broccoli Bacon Salad",
                                                    fill: true
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
}


/***/ }),

/***/ 91245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WelcomeHero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/welcomeHero/welcomeHero.module.scss
var welcomeHero_module = __webpack_require__(47507);
var welcomeHero_module_default = /*#__PURE__*/__webpack_require__.n(welcomeHero_module);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(18074);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Search2LineIcon.js
var Search2LineIcon = __webpack_require__(67899);
var Search2LineIcon_default = /*#__PURE__*/__webpack_require__.n(Search2LineIcon);
// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(77262);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(21697);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/remixicon-react/MapPinRangeLineIcon.js
var MapPinRangeLineIcon = __webpack_require__(50931);
var MapPinRangeLineIcon_default = /*#__PURE__*/__webpack_require__.n(MapPinRangeLineIcon);
// EXTERNAL MODULE: ./constants/config.ts
var config = __webpack_require__(3075);
// EXTERNAL MODULE: ./utils/getAddressFromLocation.ts
var getAddressFromLocation = __webpack_require__(60291);
;// CONCATENATED MODULE: ./utils/roundToHundreds.ts
function roundToHundreds(number) {
    const num = Number(number);
    if (!num) {
        return 0;
    }
    return Math.floor(num / 100) * 100;
}

;// CONCATENATED MODULE: ./utils/getShorterNumber.ts
function getShorterNumber(number) {
    let decPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, minShorter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!number) {
        return 0;
    }
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = 10 ** decPlaces;
    // Enumerate number abbreviations
    const abbrev = [
        " K",
        " M",
        " B",
        " T"
    ];
    // Go through the array backwards, so we do the largest first
    for(let i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        const size = 10 ** ((i + 1) * 3);
        const minSize = 10 ** minShorter;
        // If the number is bigger or equal do the abbreviation
        if (size <= number && minSize < number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += Number(abbrev[i]);
            break;
        }
    }
    return number;
}
/* harmony default export */ var utils_getShorterNumber = (getShorterNumber);

;// CONCATENATED MODULE: ./components/welcomeHero/welcomeHero.tsx














const Map = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8088), __webpack_require__.e(6555)]).then(__webpack_require__.bind(__webpack_require__, 86555)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(86555)
            ]
    },
    ssr: false
});
function WelcomeHero(param) {
    let { data , stats  } = param;
    const { t , locale  } = (0,useLocale/* default */.Z)();
    const inputRef = (0,react.useRef)();
    const { push  } = (0,router.useRouter)();
    const { updateAddress , updateLocation  } = (0,settings_context/* useSettings */.r)();
    const [location, setLocation] = (0,react.useState)({
        lat: 0,
        lng: 0
    });
    const onSubmit = (event)=>{
        var ref;
        event.preventDefault();
        if (!location.lat && !location.lng) {
            return;
        }
        updateAddress((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.value);
        updateLocation("".concat(location.lat, ",").concat(location.lng));
        push("/");
    };
    const chooseDefaultAddress = async ()=>{
        const latlng = (config/* DEFAULT_LOCATION */.PX === null || config/* DEFAULT_LOCATION */.PX === void 0 ? void 0 : config/* DEFAULT_LOCATION.split */.PX.split(",")) || [];
        setLocation({
            lat: Number(latlng[0] || 0),
            lng: Number(latlng[1] || 0)
        });
        inputRef.current.value = await (0,getAddressFromLocation/* getAddressFromLocation */.K)(config/* DEFAULT_LOCATION */.PX);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (welcomeHero_module_default()).container,
                style: {
                    backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : data.img, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "welcome-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (welcomeHero_module_default()).wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (welcomeHero_module_default()).block,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (welcomeHero_module_default()).title,
                                    children: data === null || data === void 0 ? void 0 : data.title[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (welcomeHero_module_default()).caption,
                                    children: data === null || data === void 0 ? void 0 : data.description[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (welcomeHero_module_default()).searchBar,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: (welcomeHero_module_default()).search,
                                            onSubmit: onSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "search",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Search2LineIcon_default()), {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    id: "search",
                                                    name: "search",
                                                    ref: inputRef,
                                                    placeholder: t("search"),
                                                    autoComplete: "off"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (welcomeHero_module_default()).btnWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                                onClick: onSubmit,
                                                children: t("ok")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (welcomeHero_module_default()).actions,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (welcomeHero_module_default()).textButton,
                                        onClick: chooseDefaultAddress,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((MapPinRangeLineIcon_default()), {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (welcomeHero_module_default()).text,
                                                children: t("choose.recomended.address")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (welcomeHero_module_default()).stats,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (welcomeHero_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (welcomeHero_module_default()).number,
                                                    children: [
                                                        roundToHundreds(stats === null || stats === void 0 ? void 0 : stats.users),
                                                        "+"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (welcomeHero_module_default()).text,
                                                    children: t("people.trust.us")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (welcomeHero_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (welcomeHero_module_default()).number,
                                                    children: [
                                                        utils_getShorterNumber(roundToHundreds(stats === null || stats === void 0 ? void 0 : stats.orders)),
                                                        "+"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (welcomeHero_module_default()).text,
                                                    children: t("delivery.was.successfull")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                location: location,
                setLocation: setLocation,
                inputRef: inputRef
            })
        ]
    });
}


/***/ }),

/***/ 83957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyChooseUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44371);
/* harmony import */ var _whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18074);




function WhyChooseUs(param) {
    let { data  } = param;
    const { t , locale  } = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "welcome-container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                children: [
                    !!(data === null || data === void 0 ? void 0 : data.features.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        children: t("why.choose.us")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().flex),
                        children: data === null || data === void 0 ? void 0 : data.features.map((item, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().card),
                                tabIndex: idx + 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().number),
                                        children: [
                                            "0",
                                            idx + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().cardTitle),
                                        children: item.title[locale]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_whyChooseUs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().text),
                                        children: item.description[locale]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                        loop: true,
                                        muted: true,
                                        autoPlay: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                            src: item.img
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 57945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FaqContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/faq/faq.module.scss
var faq_module = __webpack_require__(44578);
var faq_module_default = /*#__PURE__*/__webpack_require__.n(faq_module);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(18074);
// EXTERNAL MODULE: ./node_modules/remixicon-react/AddLineIcon.js
var AddLineIcon = __webpack_require__(69675);
var AddLineIcon_default = /*#__PURE__*/__webpack_require__.n(AddLineIcon);
;// CONCATENATED MODULE: ./containers/faq/faqItem.tsx




function FaqItem(param) {
    let { data  } = param;
    var ref, ref1;
    const [isOpen, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((faq_module_default()).item, " ").concat(isOpen ? (faq_module_default()).active : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (faq_module_default()).header,
                onClick: ()=>setOpen(!isOpen),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (faq_module_default()).label,
                        children: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (faq_module_default()).body,
                children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.answer
            })
        ]
    });
}

;// CONCATENATED MODULE: ./containers/faq/faq.tsx





function FaqContainer(param) {
    let { data  } = param;
    const { t  } = (0,useLocale/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (faq_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "welcome-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (faq_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (faq_module_default()).title,
                        children: t("faq")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).accordion,
                        children: data === null || data === void 0 ? void 0 : data.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FaqItem, {
                                data: item
                            }, item.id))
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 56060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PopoverContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65724);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);




const Wrapper = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((param)=>{
    let { customStyles  } = param;
    return {
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0)"
        },
        "& .MuiPaper-root": {
            backgroundColor: "var(--secondary-bg)",
            boxShadow: "var(--popover-box-shadow)",
            borderRadius: "25px",
            maxWidth: "100%",
            ...customStyles
        }
    };
});
function PopoverContainer(param) {
    let { children , customStyles , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        customStyles: customStyles,
        ...rest,
        children: children
    });
}


/***/ }),

/***/ 76807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WelcomeContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/welcome/welcome.module.scss
var welcome_module = __webpack_require__(92895);
var welcome_module_default = /*#__PURE__*/__webpack_require__.n(welcome_module);
// EXTERNAL MODULE: ./contexts/theme/theme.context.tsx
var theme_context = __webpack_require__(80108);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./services/information.ts
var information = __webpack_require__(49073);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(21697);
// EXTERNAL MODULE: ./containers/errorBoundary/errorBoundary.tsx
var errorBoundary = __webpack_require__(15924);
// EXTERNAL MODULE: ./components/welcomeHeader/welcomeHeader.module.scss
var welcomeHeader_module = __webpack_require__(42909);
var welcomeHeader_module_default = /*#__PURE__*/__webpack_require__.n(welcomeHeader_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(29969);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(18074);
// EXTERNAL MODULE: ./components/profileDropdown/profileDropdown.tsx
var profileDropdown = __webpack_require__(21502);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/welcomeHeader/welcomeHeader.tsx








function WelcomeHeader() {
    const { t  } = (0,useLocale/* default */.Z)();
    const { openAuthModal , isAuthenticated , user  } = (0,auth_context/* useAuth */.a)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "welcome-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (welcomeHeader_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        className: (welcomeHeader_module_default()).brandLogo,
                        "aria-label": "Gloco home",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/gloco-white.png",
                            alt: "Gloco",
                            width: 136,
                            height: 50,
                            className: (welcomeHeader_module_default()).brandLogoImg,
                            loading: "eager",
                            decoding: "async",
                            priority: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (welcomeHeader_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/about",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("about")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("blog")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/careers",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("careers")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(profileDropdown["default"], {
                        data: user
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: openAuthModal,
                        className: (welcomeHeader_module_default()).login,
                        children: t("login")
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./containers/layout/footer/footer.tsx
var footer = __webpack_require__(44190);
;// CONCATENATED MODULE: ./containers/welcome/welcome.tsx










function WelcomeContainer(param) {
    let { children  } = param;
    const { isDarkMode  } = (0,react.useContext)(theme_context/* ThemeContext */.N);
    const { updateSettings  } = (0,settings_context/* useSettings */.r)();
    (0,es.useQuery)("settings", ()=>information/* default.getSettings */.Z.getSettings(), {
        onSuccess: (data)=>{
            const obj = createSettings(data.data);
            updateSettings({
                payment_type: obj.payment_type,
                instagram_url: obj.instagram,
                facebook_url: obj.facebook,
                twitter_url: obj.twitter,
                referral_active: obj.referral_active,
                otp_expire_time: obj.otp_expire_time,
                customer_app_android: obj.customer_app_android,
                customer_app_ios: obj.customer_app_ios,
                delivery_app_android: obj.delivery_app_android,
                delivery_app_ios: obj.delivery_app_ios,
                vendor_app_android: obj.vendor_app_android,
                vendor_app_ios: obj.vendor_app_ios,
                group_order: obj.group_order,
                footer_text: obj.footer_text,
                ui_type: obj.ui_type,
                address_text: obj.address,
                phone: obj.phone,
                email: obj.email,
                reservation_time_durations: obj.reservation_time_durations,
                reservation_before_time: obj.reservation_before_time,
                min_reservation_time: obj.min_reservation_time,
                active_parcel: obj.active_parcel,
                before_order_phone_required: obj.before_order_phone_required,
                reservation_enable_for_user: obj.reservation_enable_for_user,
                google_map_key: obj.google_map_key,
                favicon: obj.favicon,
                title: obj.title,
                generalSettingsLocation: obj.location,
                logo: obj.logo
            });
        }
    });
    function createSettings(list) {
        const result = list.map((item)=>({
                [item.key]: item.value
            }));
        return Object.assign({}, ...result);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(errorBoundary/* default */.Z, {
        isDarkMode: isDarkMode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (welcome_module_default()).body,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 58287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePopover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function usePopover() {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event)=>{
        return setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    const handleClose = ()=>setAnchorEl(null);
    return [
        open,
        anchorEl,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 12838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const blogService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/paginate?type=blog", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/".concat(id), {
            params
        }),
    getLastBlog: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/last-blog/show", {
            params
        }),
    getAllNews: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/paginate?type=notification", {
            params
        }),
    getNewsById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (blogService);


/***/ }),

/***/ 46822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const faqService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/faqs/paginate", {
            params
        }),
    getPrivacy: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/policy", {
            params
        }),
    getTerms: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/term", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (faqService);


/***/ }),

/***/ 70855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const pageService = {
    getDeliverPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/delivery", {
            params
        }),
    getAboutPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/about", {
            params
        }),
    getAboutSections: ()=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/paginate?page=1&perPage=10&type=all_about"),
    getLandingPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/landing-pages/welcome", {
            params
        }),
    getStatistics: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/stat", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (pageService);


/***/ }),

/***/ 60291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getAddressFromLocation; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87066);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5848);


async function getAddressFromLocation(latlng) {
    let params = {
        latlng,
        key: constants_constants__WEBPACK_IMPORTED_MODULE_0__/* .MAP_API_KEY */ .kr
    };
    return axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("https://maps.googleapis.com/maps/api/geocode/json", {
        params
    }).then((param)=>{
        let { data  } = param;
        var ref;
        return (ref = data.results[0]) === null || ref === void 0 ? void 0 : ref.formatted_address;
    }).catch((error)=>{
        console.log(error);
        return "not found";
    });
}


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAvatar; }
/* harmony export */ });
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5848);

const avatar_placeholder = "/images/avatar_placeholder.png";
function getAvatar(img) {
    if (img) {
        return img.includes("http") ? img : constants_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_URL */ .yA + img;
    } else {
        return avatar_placeholder;
    }
}


/***/ }),

/***/ 30405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getNearestFloor; }
/* harmony export */ });
function getNearestFloor(number) {
    return Math.floor((number || 0) * 100) / 100;
}


/***/ }),

/***/ 76098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 58203:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileBtn":"profileDropdown_profileBtn__lUVki","imgWrapper":"profileDropdown_imgWrapper__6btm2","login":"profileDropdown_login__iC6C_","wrapper":"profileDropdown_wrapper__GR3_r","closeIcon":"profileDropdown_closeIcon__QmpuM","header":"profileDropdown_header__rbpis","naming":"profileDropdown_naming__3WG7e","title":"profileDropdown_title__ythS3","profileImage":"profileDropdown_profileImage__HL_Z_","body":"profileDropdown_body__Tqeyo","flex":"profileDropdown_flex__pAYIs","text":"profileDropdown_text__CCJs4","price":"profileDropdown_price__7biJh","badge":"profileDropdown_badge__wjFQg"};

/***/ }),

/***/ 72746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"welcomeBlog_container__y6S2h","wrapper":"welcomeBlog_wrapper__KbPnV","imgWrapper":"welcomeBlog_imgWrapper__66zxU","header":"welcomeBlog_header__4t6DY","heading":"welcomeBlog_heading__2Fk3f","link":"welcomeBlog_link__ohilf","text":"welcomeBlog_text__poL0F","card":"welcomeBlog_card__BSgQN","title":"welcomeBlog_title__CXb2C","body":"welcomeBlog_body__b5jRI","small":"welcomeBlog_small__82U1X","float":"welcomeBlog_float___fDdl","badge":"welcomeBlog_badge__12vEa","socialCard":"welcomeBlog_socialCard__ju7Xo","label":"welcomeBlog_label__VeAhY"};

/***/ }),

/***/ 42909:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"welcomeHeader_header__W0dt6","navItem":"welcomeHeader_navItem__HT6UE","brandLogo":"welcomeHeader_brandLogo__9VGOU","menuBtn":"welcomeHeader_menuBtn__P68b0","login":"welcomeHeader_login__8PDUP","searchBar":"welcomeHeader_searchBar__w4c58","actions":"welcomeHeader_actions__6AIyc","itemLink":"welcomeHeader_itemLink__fxTTB"};

/***/ }),

/***/ 47507:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"welcomeHero_container__9pjs8","wrapper":"welcomeHero_wrapper__DwYEy","block":"welcomeHero_block__ytj16","title":"welcomeHero_title__1sS8K","caption":"welcomeHero_caption__hHMNy","searchBar":"welcomeHero_searchBar__w5Li7","search":"welcomeHero_search__Ciw_C","btnWrapper":"welcomeHero_btnWrapper__tPlRB","actions":"welcomeHero_actions__33DX8","textButton":"welcomeHero_textButton__gSIxd","text":"welcomeHero_text__VytOH","stats":"welcomeHero_stats__A5YAB","item":"welcomeHero_item__2BztM","number":"welcomeHero_number__HPfbA"};

/***/ }),

/***/ 44371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"whyChooseUs_container__slc__","wrapper":"whyChooseUs_wrapper__8W8_r","title":"whyChooseUs_title__CAGVp","flex":"whyChooseUs_flex__hqVUO","card":"whyChooseUs_card__TAJSM","number":"whyChooseUs_number__su9RD","cardTitle":"whyChooseUs_cardTitle__2U4eQ","text":"whyChooseUs_text__QDmED"};

/***/ }),

/***/ 44578:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__vnQGp","wrapper":"faq_wrapper__PiQ4h","title":"faq_title__CbXm3","accordion":"faq_accordion__Kaq_0","item":"faq_item__OK2MG","header":"faq_header__4NHR5","label":"faq_label__Cpkzw","body":"faq_body__7jCGR","active":"faq_active___S_pn"};

/***/ }),

/***/ 92895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"welcome_body__7TUQ9"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 69675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AddLineIcon = function AddLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z' })
  );
};

var AddLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(AddLineIcon) : AddLineIcon;

module.exports = AddLineIcon$1;


/***/ }),

/***/ 94187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightLineIcon = function ArrowRightLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z' })
  );
};

var ArrowRightLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightLineIcon) : ArrowRightLineIcon;

module.exports = ArrowRightLineIcon$1;


/***/ }),

/***/ 46550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CloseLineIcon = function CloseLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z' })
  );
};

var CloseLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(CloseLineIcon) : CloseLineIcon;

module.exports = CloseLineIcon$1;


/***/ }),

/***/ 50931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPinRangeLineIcon = function MapPinRangeLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074zM12 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4z' })
  );
};

var MapPinRangeLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPinRangeLineIcon) : MapPinRangeLineIcon;

module.exports = MapPinRangeLineIcon$1;


/***/ }),

/***/ 67899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Search2LineIcon = function Search2LineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm0 16c3.867 0 7-3.133 7-7 0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7zm8.485.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z' })
  );
};

var Search2LineIcon$1 = React__default['default'].memo ? React__default['default'].memo(Search2LineIcon) : Search2LineIcon;

module.exports = Search2LineIcon$1;


/***/ })

}]);